"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_KNOWLEDGE = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const route_1 = require("../route");
const firestore_1 = require("firebase/firestore");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
require("./style.css");
exports.LIST_KNOWLEDGE = route_1.KNOWLEDGE.sub("/list", KnowledgeList);
function KnowledgeList() {
    const { projectId } = (0, react_router_dom_1.useParams)();
    const [knowledgeList, setKnowledgeList] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [editingKnowledge, setEditingKnowledge] = (0, react_1.useState)(null);
    const [formData, setFormData] = (0, react_1.useState)({
        name: "",
        condition: "",
        knowledge: "",
    });
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
    (0, react_1.useEffect)(() => {
        fetchKnowledge();
    }, [projectId, firestore]);
    const fetchKnowledge = () => __awaiter(this, void 0, void 0, function* () {
        if (!projectId)
            return;
        try {
            setLoading(true);
            const knowledgeQuery = (0, firestore_1.query)((0, firestore_1.collection)(firestore, "knowledge"), (0, firestore_1.where)("project_id", "==", projectId));
            const snapshot = yield (0, firestore_1.getDocs)(knowledgeQuery);
            const knowledge = snapshot.docs.map((doc) => (Object.assign({ id: doc.id }, doc.data())));
            setKnowledgeList(knowledge);
            setError(null);
        }
        catch (err) {
            console.error("知識データの取得に失敗しました:", err);
            setError("知識データの取得に失敗しました");
        }
        finally {
            setLoading(false);
        }
    });
    const openCreateModal = () => {
        setFormData({
            name: "",
            condition: "",
            knowledge: "",
        });
        setEditingKnowledge(null);
        setIsModalOpen(true);
    };
    const openEditModal = (knowledge) => {
        setFormData({
            name: knowledge.name,
            condition: knowledge.condition,
            knowledge: knowledge.knowledge,
        });
        setEditingKnowledge(knowledge);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setEditingKnowledge(null);
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
    };
    const handleSubmit = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        if (!projectId)
            return;
        try {
            setIsSubmitting(true);
            if (editingKnowledge) {
                // 更新処理
                yield (0, firestore_1.updateDoc)((0, firestore_1.doc)(firestore, "knowledge", editingKnowledge.id), {
                    name: formData.name,
                    condition: formData.condition,
                    knowledge: formData.knowledge,
                    updatedAt: (0, firestore_1.serverTimestamp)(),
                });
            }
            else {
                // 新規作成処理
                yield (0, firestore_1.addDoc)((0, firestore_1.collection)(firestore, "knowledge"), {
                    project_id: projectId,
                    name: formData.name,
                    condition: formData.condition,
                    knowledge: formData.knowledge,
                    evaluation: 1,
                    createdAt: (0, firestore_1.serverTimestamp)(),
                });
            }
            closeModal();
            fetchKnowledge();
        }
        catch (err) {
            console.error("知識データの保存に失敗しました:", err);
            alert("知識データの保存に失敗しました");
        }
        finally {
            setIsSubmitting(false);
        }
    });
    const handleDelete = (id) => __awaiter(this, void 0, void 0, function* () {
        if (!window.confirm("本当にこの知識を削除しますか？"))
            return;
        try {
            setLoading(true);
            yield (0, firestore_1.deleteDoc)((0, firestore_1.doc)(firestore, "knowledge", id));
            fetchKnowledge();
        }
        catch (err) {
            console.error("知識データの削除に失敗しました:", err);
            alert("知識データの削除に失敗しました");
        }
        finally {
            setLoading(false);
        }
    });
    // 条件を表示するヘルパー関数（JSONではなくテキストとして表示）
    const renderCondition = (conditionStr) => {
        return react_1.default.createElement("div", null, conditionStr);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: "hero" },
            react_1.default.createElement("div", { className: "hero-body" },
                react_1.default.createElement("div", { className: "level" },
                    react_1.default.createElement("div", { className: "level-left" },
                        react_1.default.createElement("h1", { className: "title" }, "\u77E5\u8B58\u4E00\u89A7")),
                    react_1.default.createElement("div", { className: "level-right" },
                        react_1.default.createElement("button", { className: "button is-primary", onClick: openCreateModal }, "\u65B0\u898F\u4F5C\u6210"))))),
        react_1.default.createElement("section", { className: "main-section" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8ID: ",
                    projectId),
                loading ? (react_1.default.createElement("div", { className: "has-text-centered" },
                    react_1.default.createElement("p", null, "\u30C7\u30FC\u30BF\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D..."),
                    react_1.default.createElement("progress", { className: "progress is-primary", max: "100" }))) : error ? (react_1.default.createElement("div", { className: "notification is-danger" }, error)) : knowledgeList.length === 0 ? (react_1.default.createElement("div", { className: "notification is-info" }, "\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u306F\u307E\u3060\u77E5\u8B58\u304C\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002")) : (react_1.default.createElement("div", { className: "table-container" },
                    react_1.default.createElement("table", { className: "table is-fullwidth is-striped is-hoverable" },
                        react_1.default.createElement("thead", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", null, "ID"),
                                react_1.default.createElement("th", null, "\u540D\u524D"),
                                react_1.default.createElement("th", null, "\u6761\u4EF6"),
                                react_1.default.createElement("th", null, "\u77E5\u8B58\u5185\u5BB9"),
                                react_1.default.createElement("th", null, "\u8A55\u4FA1"),
                                react_1.default.createElement("th", null, "\u64CD\u4F5C"))),
                        react_1.default.createElement("tbody", null, knowledgeList.map((item) => (react_1.default.createElement("tr", { key: item.id },
                            react_1.default.createElement("td", null, item.id),
                            react_1.default.createElement("td", null, item.name),
                            react_1.default.createElement("td", null, renderCondition(item.condition)),
                            react_1.default.createElement("td", null, item.knowledge),
                            react_1.default.createElement("td", null, item.evaluation),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("div", { className: "buttons" },
                                    react_1.default.createElement("button", { className: "button is-primary", onClick: () => openEditModal(item) }, "\u7DE8\u96C6"),
                                    react_1.default.createElement("button", { className: "button is-warning", style: {
                                            backgroundColor: "#ff8c00",
                                            color: "white",
                                        }, onClick: () => handleDelete(item.id) }, "\u524A\u9664")))))))))))),
        react_1.default.createElement("div", { className: `modal ${isModalOpen ? "is-active" : ""}` },
            react_1.default.createElement("div", { className: "modal-background", onClick: closeModal }),
            react_1.default.createElement("div", { className: "modal-card" },
                react_1.default.createElement("header", { className: "modal-card-head" },
                    react_1.default.createElement("p", { className: "modal-card-title" }, editingKnowledge ? "知識の編集" : "新規知識の作成"),
                    react_1.default.createElement("button", { className: "delete", "aria-label": "close", onClick: closeModal })),
                react_1.default.createElement("section", { className: "modal-card-body" },
                    react_1.default.createElement("form", { onSubmit: handleSubmit },
                        react_1.default.createElement("div", { className: "field" },
                            react_1.default.createElement("label", { className: "label" }, "\u540D\u524D"),
                            react_1.default.createElement("div", { className: "control" },
                                react_1.default.createElement("input", { className: "input", type: "text", name: "name", value: formData.name, onChange: handleInputChange, required: true }))),
                        react_1.default.createElement("div", { className: "field" },
                            react_1.default.createElement("label", { className: "label" }, "\u6761\u4EF6"),
                            react_1.default.createElement("div", { className: "control" },
                                react_1.default.createElement("textarea", { className: "textarea", name: "condition", value: formData.condition, onChange: handleInputChange, required: true })),
                            react_1.default.createElement("p", { className: "help" }, "\u4F8B: \u300C\u30D5\u30A1\u30F3\u30BF\u30B8\u30FC\u30B8\u30E3\u30F3\u30EB\u3001\u5B50\u4F9B\u5411\u3051\u30B3\u30F3\u30C6\u30F3\u30C4\u300D\u306E\u3088\u3046\u306B\u6761\u4EF6\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044")),
                        react_1.default.createElement("div", { className: "field" },
                            react_1.default.createElement("label", { className: "label" }, "\u77E5\u8B58\u5185\u5BB9"),
                            react_1.default.createElement("div", { className: "control" },
                                react_1.default.createElement("textarea", { className: "textarea", name: "knowledge", value: formData.knowledge, onChange: handleInputChange, required: true }))))),
                react_1.default.createElement("footer", { className: "modal-card-foot" },
                    react_1.default.createElement("button", { className: `button is-primary ${isSubmitting ? "is-loading" : ""}`, onClick: handleSubmit, disabled: isSubmitting }, "\u4FDD\u5B58"),
                    react_1.default.createElement("button", { className: "button", onClick: closeModal }, "\u30AD\u30E3\u30F3\u30BB\u30EB"))))));
}
exports.default = KnowledgeList;
